import { NoResultCard, NoResultCardProps } from "./no-results-card";
import { StatCard, StatCardProps } from "./stat-card";

import { SimpleGrid } from "@chakra-ui/react";
import * as React from "react";
import {
  ProgressStatCard,
  ProgressStatCardProps,
} from "../../progress-stat-card";
import {
  CollapsibleStatSectionWrapperProps,
  CollapsibleStatsSectionWrapper,
} from "./collapsible-stats-section-wrapper";

export interface CollapsibleStatSectionProps
  extends CollapsibleStatSectionWrapperProps {
  title: string;
  subtitle: React.ReactNode;
  stats: Array<StatCardProps | ProgressStatCardProps>;
  colorScheme?: string;
  noRes?: NoResultCardProps;
}
export const CollapsibleStatSection: React.FC<CollapsibleStatSectionProps> = ({
  stats,
  title,
  subtitle,
  colorScheme,
  noRes,
  knowledgeCenterSlug,
  children,
}) => {
  return (
    <CollapsibleStatsSectionWrapper
      {...{ title, subtitle, colorScheme, knowledgeCenterSlug }}
    >
      {noRes ? (
        <NoResultCard {...noRes} />
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing="6">
          {stats.map(
            (stat: StatCardProps | ProgressStatCardProps, id: number) =>
              (stat as ProgressStatCardProps)?.caption ? (
                <ProgressStatCard
                  key={id}
                  {...(stat as ProgressStatCardProps)}
                  colorScheme={colorScheme}
                />
              ) : (
                <StatCard
                  key={id}
                  {...(stat as StatCardProps)}
                  colorScheme={colorScheme}
                />
              ),
          )}
          {children}
        </SimpleGrid>
      )}
    </CollapsibleStatsSectionWrapper>
  );
};
